/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAppSelector } from '@ibm-watson/shared/store';
import { didSubscribeIntegrationSucceed } from '../../../store/channels/selectors';
import { QuickSetupComponentProps } from '../../../util/types';
import { WebhookStepMessages as messages } from './messages';
import { WebhookContent } from './WebhookContent';

export const WebhookStep = ({
  assistantId,
  environmentId,
  markStepComplete
}: QuickSetupComponentProps) => {
  const subscribeSucceeded = useAppSelector(didSubscribeIntegrationSucceed);

  // When field is valid, we need to mark this step complete...
  useEffect(() => {
    markStepComplete(subscribeSucceeded);
  }, [markStepComplete, subscribeSucceeded]);

  return (
    <div className="TabContent__body-content TabContent__body-outdent">
      <div className="QuickSetup__step-title">
        <FormattedMessage {...messages.title} />
      </div>
      <div className="TabContent__spacer8" />
      <WebhookContent
        assistantId={assistantId}
        environmentId={environmentId}
        isQuickSetup
      />
    </div>
  );
};
